import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useCancelPolicyData } from "../../../lib/useMockData";

export default function PolicySection() {
  const { policyData } = useCancelPolicyData();
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10">
              <p className="section-label mb-3">{policyData.label}</p>
              <h2 className="section-title">{policyData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="flex flex-col gap-4">
            {policyData.items.map((item, idx) => (
              <ScrollReveal key={item.period} direction="up" delay={idx * 80}>
                <div className="p-5 md:p-6 bg-white border border-airdoa-gray-light/50 rounded-lg">
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-3">
                    <h3 className="text-base font-serif font-semibold text-airdoa-navy">{item.period}</h3>
                    <span className="inline-block px-3 py-1 text-xs font-medium bg-airdoa-cream text-airdoa-navy rounded">{item.fee}</span>
                  </div>
                  <p className="text-sm text-airdoa-gray leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}